import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { getAppCategories } from './-query/api';
import { SearchSchema } from './-schema';

export const Route = createFileRoute(
  '/_staff/software/custom-saas/add/$customSaasType/',
)({
  component: () =>
    import('./index.lazy').then((d) => d.Route.options.component),
  validateSearch: zodValidator(SearchSchema),
  loader: async () => {
    const categories = await getAppCategories();
    return { categories } as const;
  },
});
